import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LocalStorageService, useHTTPError } from 'br2s-ui-common-utils-02';
import { useStore } from '@/redux/store';
import { AuthAPI } from '@/services/api/auth';
import { checkIfShouldSfv } from '@/utilities/utilities';
import sfv from '@/config/sfvTransactions_config.json';

type SfvGuardProps = {
  children: React.ReactNode;
};

const SfvGuard = ({ children }: SfvGuardProps) => {
  const { toggleLoading, toggleSfvAttempt } = useStore();
  const location = useLocation();
  const { handleHTTPError } = useHTTPError();
  const hasAuth = LocalStorageService.hasAuth();
  const isSfvTransaction = sfv.transactions.some((url) =>
    location.pathname.includes(url),
  );
  const shouldSfv = checkIfShouldSfv(location.pathname) && hasAuth;

  useEffect(() => {
    if (isSfvTransaction && !LocalStorageService.hasAuth()) {
      toggleSfvAttempt();
      LocalStorageService.setUrlPriorToLogin(location.pathname);
      return;
    }

    if (shouldSfv) {
      toggleLoading(true);

      const getKickoff = async () => {
        try {
          const response = await AuthAPI.getKickoffRedirectUrl({
            loginType: 'Individual',
            sfv: true,
          });

          if (response?.status === 200) {
            LocalStorageService.setUrlPriorToLogin(location.pathname);
            const { kickOffUrl } = response.data.result;

            // istanbul ignore next
            window.open(kickOffUrl, '_self');
          }
        } catch (error) {
          console.error(error);
          handleHTTPError(error);
          toggleLoading(false);
        }
      };

      getKickoff();
    }
  }, [location.pathname, isSfvTransaction, shouldSfv]);

  if (shouldSfv) return <></>;

  return <>{children}</>;
};

export default SfvGuard;
